import React, { Fragment, Component} from 'react';
import { connect, batch } from 'react-redux';
// Components
import SurveyPage from './SurveyPage/SurveyPage';
import ThankYouPage from '../../components/SurveySubmit/ThankYouPage';
import CompletionNoticeSection from '../../components/Section/CompletionNoticeSection'
// Actions
import {
	getSurvey,
	getSessionHeader,
	getInstrument,
	// getAllResponse,
	getAssessmentInfoForDataCollection,
	getAssessmentInfosForDataCollection
} from '../../../actions/SurveyAction';
import Modal from 'react-bootstrap/Modal';
import { isBrowser, isMobile, isTablet } from 'react-device-detect';
import LoadingIndicator from '../../../utilities/LoadingIndicator';
// import { getAssessmentInfosForDataCollection }  from '../../../../services/SurveyServices';

const instrumentObj = {
	"nextButtonText"     : {"label": "Next"},
	"finishButtonText"   : {"label": "Finish"},
    "backButtonText"     : {"label": "Back", "icon": `<i class="fa fa-chevron-left" aria-hidden="true"></i>`},
    "submitButtonText"   : {"label": "Submit"},
    "saveLaterButtonText": {"label": "Save for Later"},
    "reviewButtonText"   : {"label": "Review Responses"},
    "saveButtonText"     : {"label": "", "icon": `<i class = "fa fa-floppy-o" aria-hidden="true"></i>`},
    "answerLabelText"    : {"label": "complete"},
	"unAnswerLabelText"  : {"label": "unanswered"},
	"reviewResponseRequiredMsg"  : {"label": `You must complete the <span class="circle-required"></span> required unanswered question to proceed`},
	"reviewResponseCompleteSurveyMsg"  : {"label": `You have completed all required question and can submit if you'd like to, however, it would be swell if you could finish unanswered question(s) as well`},
	"finishPageHeading":{"label": "Thank you for Taking"},
	"finishPageSubHeading":{"label": "Are you Leader Who Knows What Matters!"},
	"finishPageCompleteLinkText":{"label": "Review Complete"},
	"finishPageUnansweredLinkText":{"label": "Review Unaswered"},
	"finishPageReviewButton":{"label": "Review All Responses"},
	"finishSurveyFooterMessage"  : {"label": `Please review your responses to answer the required question to completed the assessment.`},
	"finishSurveyFooterSuccessMessage"  : {"label": `Fill free to <strong onclick="this.props.openModal("unanswered", true)" class="card-footer-link-label"> review your responses</strong> or submit the assessment.`},
	"finishSurveyFooterRequiredMessage"  : {"label": `We value your input, therefore, we would appreciate it if you could <strong class="card-footer-link-label"> review your responses</strong> to answer any you may have missed However, if you are finished with assessment, please click submit.`},
	"finishPageModalUnansweredHeading":{"label": "To submit your responses, you need to answer the require question"},
	"finishPageModalRequiredHeading":{"label": "There are just a few unanswered question, while they are not required, it would be swell if you could take a look answer them, You may also submit at this time."},
	"saveLaterPageHeading":{"label": "Your assessment was saved successfully!"},
	"saveLaterPageSubHeading":{"label": "Take a movement to review your responses, Feel free to edit"},
};

class Survey extends Component {
    constructor (props) {
        super(props);
        this.state = {
			survey: {},
			pageInstrumentConfiguration:{},
			activePageNumber: null,
			currentActivePageCount:0,
			ratees: [],
			isFinish:false,
			instrumentCss:'',
			dataCollectionGuid:null,
			authorizationTokenGuid:null,
			sessionHeader:null,
			divOrientation: "",
			unAnsweredPage: 0,
			itemResponseSet:[],
			allDataCollectionGuids:null,
			surveyGuids:0,
			unAnsweredFlag:null,
            isLoading:true,
			goToBackPage:false,
			revisit : true
		};
		this.handlePreviousButtonClick = this.handlePreviousButtonClick.bind(this);
		this.handleNextButtonClick = this.handleNextButtonClick.bind(this);
		this.surveyRef = React.createRef();
		this.itemResponses = {};
		this.itemTempResponses = {};
		this.putAllForMultipleCollection = {};
		this.putAllForItemCollection= {};
		this.elapsedTimeForPutAll = null;
		this.items = [];
		this.pageNumber = 0;
		this.skipFlag = true;
		this.openModal = false;

	}


    static getDerivedStateFromProps = (props, state) => {
		const surveyList = props.surveyList;
		const {skipToFirstUnanswered} = surveyList;
		state.unAnsweredFlag = skipToFirstUnanswered;
		const items = state.itemResponseSet;
		const { ...itemsData } = items;
		var lastPageNumber = surveyList !== undefined && surveyList.pages !== undefined ? surveyList.pages.length : 0;
		var countPage = surveyList !== undefined && surveyList.pages !== undefined ? surveyList.pages.filter((pageCount) => {
			if (pageCount.countPage === true) {
				return surveyList.pages.length;
			}
		}) : 0;
        var activePageNumberToRedirect = null;
		if(skipToFirstUnanswered !== undefined && !skipToFirstUnanswered) {
		activePageNumberToRedirect =  (surveyList !== undefined && surveyList.pages !== undefined && surveyList.pages.findIndex(pages => pages.isSkipPage !== true && pages.key === surveyList.activePageKey)) + 1;
		} else {
			if (state.revisit) {				
				var unAnsweredItemKey = [];
				if (Array.isArray(surveyList.pages)) {
					let breakOuterLoop = false;
					if (state.surveyGuids.length > 2) {
					if (itemsData[0] && typeof itemsData[0] === 'object') {
						var values = Object.values(itemsData[0]);
							for (let k = 0; k < values.length; k++) {
								const response = values[k];
								const respData = response.itemResponses;
								if (response.itemKey && respData[0].responseValue === null) {
									if (respData[0].itemType === "-1" || respData[0].itemType === -1) {
										if (respData[0].openEnd === null) {
											unAnsweredItemKey.push(response.itemKey);
										}
									} else {
										unAnsweredItemKey.push(response.itemKey);
									}
								}
							}
						}
							if (unAnsweredItemKey.length > 0) {
								for (let i = 0; i < surveyList.pages.length; i++) {
									const page = surveyList.pages[i];
									for (let j = 0; j < page.items.length; j++) {
										const item = page.items[j];
										if (unAnsweredItemKey.includes(item.key)) {
											state.activePageNumber = item.activePageNumber === 2 ? 1 : item.activePageNumber;
											state.revisit = false;
											breakOuterLoop = true;
											break;
										}
									}
									if (breakOuterLoop) {
										break;
									}
								}
							}
							state.isLoading = false;
						}
					else {
						for (let i = 0; i < surveyList.pages.length; i++) {
							const page = surveyList.pages[i];
							if (page.items && page.items.length > 0) {
								for (let j = 0; j < page.items.length; j++) {
									const item = page.items[j];
									if (item.activePageNumber !== undefined && !item.isAnswer) {
										state.activePageNumber = item.activePageNumber === 2 ? 1 : item.activePageNumber;
										state.revisit = false;
										breakOuterLoop = true;
										break;
									}
								}
							}
							if (breakOuterLoop) {
								state.isLoading = false;
								break;
							}
						}
					}
				}
			}
    }
			
        if (surveyList !== state.survey || props.sessionHeader !== state.sessionHeader) {
			let css = surveyList.instrumentCSS;
			// Dynamic CSS
			if (css && css !== undefined) {
				var head = document.head || document.getElementsByTagName('head')[0];
				var style = document.createElement('style');

				if (style) {
					head.appendChild(style);
					style.type = 'text/css';

					if (style.styleSheet) {
						style.styleSheet.cssText = css;
					} else {
						style.appendChild(document.createTextNode(css));
					}
				}

				for (const key in surveyList.htmlHeadElements) {
					if (surveyList.htmlHeadElements.hasOwnProperty(key)) {
					  const element = surveyList.htmlHeadElements[key];
					  document.head.insertAdjacentHTML('beforeend', element);
					}
				}
			}

			// Code to add header scripts
			if(surveyList.trackingCodeJavascript !== null && surveyList.trackingCodeJavascript !== undefined ) {
				const re = /<script\b[^>]*>[\s\S]*?<\/script\b[^>]*>/g;
				const results = surveyList.trackingCodeJavascript.match(re);
				var finalResult = [];
				if (results !== null && results.length > 0){
					for (let index = 0; index < results.length; index++){
						var str = results[index];
						//replace the text javascript if its already in string, as we are appending while creating node
						//get the source 
						var srcRegex = /<script.*?src="(.*?)"/;
						var srcUrl = srcRegex.exec(str) != null ? srcRegex.exec(str)[1]: '';
						
						//get async, defer
						var isAsync = str.indexOf(' async ') != -1? 1: 0;
						var isDefer = str.indexOf(' defer ') != -1? 1: 0;
						
						//get the id
						var idRegex = /<script.*?id="(.*?)"/;
						var idValue = idRegex.exec(str) != null ? idRegex.exec(str)[1]: '';
						
						// get the code between scripts
						var code = '';
						// if (srcUrl == ''){
						// 	code = str.replace('<script>', '');
						// 	code = code.replace('</script>', '');
						// }

						if (srcUrl == '' || str.substr("text/javascript")){
							code = str.replace('<script>', '');
							code = code.replace('</script>', '');
							code = code.replace('<script type="text/javascript">', '')
						}
						
						let finalResultObj = {
							'id': idValue,
							'src': srcUrl,
							'code': code,
							'async': isAsync,
							'defer': isDefer
						}
						
						finalResult.push(finalResultObj);
					}
				}

				// Code append scripts
				var result = finalResult;
				if (result.length > 0){
					for (let index = 0; index < result.length; index++){
						var data = result[index];
						var head = document.getElementsByTagName('head')[0];
						var script = document.createElement('script');
						script.type = 'text/javascript';
						if (data.src != ''){
							script.src = data.src;
						}
						if (data.id != ''){
							script.id = data.id;
						}
						if (data.async != 0){
							script.async = true;
						}
						if (data.defer != 0){
							script.defer = true;
						}
						if (data.code != ''){
							script.innerHTML  = data.code;
						}
						head.appendChild(script);
					}
				  }
			}

			//page Refresh
			// const currentPage = JSON.parse(sessionStorage.getItem("pageNumber"));
            return {
                survey:surveyList || [],
				activePageNumber: (skipToFirstUnanswered !== undefined && !skipToFirstUnanswered) ? activePageNumberToRedirect : state.activePageNumber !== null ? state.activePageNumber : 1,
				pageInstrumentConfiguration:surveyList,
				instrumentCss:props.instrumentCss,
				currentActivePageCount:lastPageNumber === countPage.length ? 1 : 0,
				sessionHeader:props.sessionHeader
            }
		};

		
		return null;
	}

	async componentDidMount () {
        this.setState({isLoading:true});
		const params = new URLSearchParams(this.props.location.search);
		const {
			getSessionHeader,
			getSurvey,
			getInstrument,
			match,
			getAssessmentInfoForDataCollection,
			getAssessmentInfosForDataCollection,
			surveyList
		} = this.props;
		this.items = surveyList.pages;
		this.state.itemResponseSet.push(this.putAllForItemCollection);
		if (params.has("guid") || true) {

			let formXmlGuid = match.params.formXmlGuid;
			// let dataCollectionGuid = match.params.dataCollectionGuid;
			let dataCollectionGuidList = match.params.dataCollectionGuid;
			this.setState({allDataCollectionGuids:dataCollectionGuidList})
			let dataCollectionGuidsCollection = dataCollectionGuidList.split(',');
			this.setState({surveyGuids:dataCollectionGuidsCollection})
			let dataCollectionGuid = dataCollectionGuidsCollection[0];
			let authorizationTokenGuid = match.params.authorizationTokenGuid;
			const dataCollectionGuidArr = ["3385a50e-8049-4a71-b571-01287f5f250c"];//, 3385a50e-8049-4a71-b571-01287f5f250c,b1587e87-46cb-497d-a584-a949c3cb5661,85b5f4f7-57d4-4196-b2a4-0ef806eb50a5
			this.elapsedTimeForPutAll = new Date();
			this.setState({dataCollectionGuid:dataCollectionGuid, authorizationTokenGuid:authorizationTokenGuid});

			batch(() => {
				getSessionHeader(authorizationTokenGuid, dataCollectionGuid, dataCollectionGuidsCollection);
				// getSurvey(formXmlGuid, dataCollectionGuidList);
				if(dataCollectionGuidsCollection.length < 2) {
					getSurvey(formXmlGuid, dataCollectionGuidsCollection[0]);
				} 
				if(dataCollectionGuidsCollection.length > 1) {
					getSurvey(formXmlGuid, dataCollectionGuidsCollection[0]+","+dataCollectionGuidsCollection[1]);
				}
				//getSurvey(formXmlGuid, dataCollectionGuid);
				getAssessmentInfoForDataCollection(dataCollectionGuid, authorizationTokenGuid);
				getAssessmentInfosForDataCollection(dataCollectionGuidsCollection, authorizationTokenGuid);
				getInstrument(instrumentObj);
			})


			if (window.innerHeight > window.innerWidth) {
				this.setState({divOrientation:'portrait'});
			} else {
				this.setState({divOrientation:'landscape'});
			} 

			window.addEventListener("resize",(event) => {
				if (window.innerHeight > window.innerWidth) {
					this.setState({divOrientation:"portrait"});
			} else {  
					this.setState({divOrientation:"landscape"})
				}
			});
		};
		
	}

	setOrientation = (event) => {
		var screenOrientation = window.outerWidth > window.outerHeight ? 90 : 0;
		alert("screenOrientation = " + screenOrientation);
	}

	async componentDidUpdate() {
		const { sessionHeader} = this.state;
		if (sessionHeader && sessionHeader !== null) {
			sessionStorage.setItem("authorizationGuid", JSON.stringify(this.state.sessionHeader));
		}		
		// sessionStorage.setItem("pageNumber", JSON.stringify(this.state.activePageNumber));
	}

    handleNextButtonClick = (index, type, currentValue) => {
		const { activePageNumber, currentActivePageCount } = this.state;
		var iFrameDetection = (window === window.parent) ? false : true;
        this.setState({goToBackPage:false})
		if (typeof type !== undefined && type === "review") {
			this.setState({
				activePageNumber: currentValue,
				isFinish:false,
				currentActivePageCount: currentValue
			});

		} else if (typeof type !== undefined && type === "reviewButton") {
			this.setState({
				activePageNumber: activePageNumber,
				currentActivePageCount: currentActivePageCount,
				isFinish:false
			});

		} else {

			this.setState({
				activePageNumber:currentValue + 1,
				isFinish:false,
				currentActivePageCount: currentActivePageCount + 1
			});
		}
		this.setState({isFinish:false})

		if (!iFrameDetection) {
			this.surveyRef.current.scrollIntoView({ behavior: 'auto' });
		}
    }

    handlePreviousButtonClick = (currentValue) => {
        this.setState({goToBackPage:true})
		const { activePageNumber, currentActivePageCount } = this.state;
		this.setState({
			activePageNumber: currentValue,
			isFinish:false,
			currentActivePageCount:currentActivePageCount - 1
		});
	}

	handleFinishButtonClick = (isFinish) => {
		this.setState({isFinish:!isFinish});
	}

	handlePageNextButton = () => {
		const { activePageNumber, currentActivePageCount } = this.state;
		var backPage = activePageNumber + 1;

		this.setState({
			activePageNumber: backPage,
			isFinish:false,
			currentActivePageCount:currentActivePageCount + 1
		});
	}

    render() {
		const { survey, isFinish, pageInstrumentConfiguration, currentActivePageCount, dataCollectionGuid, authorizationTokenGuid } = this.state;
		const { sections, properties } = pageInstrumentConfiguration;

		const { assessmentInfoDataCollection } = this.props;
		var completedNoticeSectionKey = pageInstrumentConfiguration.completedNoticeSectionKey;

        var pageNumber = this.pageNumber;
		// var lastPageNumber = survey !== undefined && survey.pages !== undefined ? survey.pages.length : 0;

		var lastPageLen = survey !== undefined && survey.pages !== undefined ? survey.pages.filter((item) => {
			return item.isSkipPage !== true;
		}):0;

		var lastPageNumber = lastPageLen.length || 0;
		var ratees = this.props.ratees;
		var activePageNumber = this.state.activePageNumber;
		var currentActivePageCountTemp = currentActivePageCount;

        if (lastPageNumber === 0) {
			return (<div></div>);
		}
		var collectionStatus = assessmentInfoDataCollection.collectionStatus;
		const tempPages = survey.pages || [];

		//var openModal = false;
		var orientationMsg = "";

		if((isMobile || isTablet) && (this.state.divOrientation == "portrait" && survey.orientation == "landscape" && survey.orientation !== "")) {
			this.openModal = true;
			orientationMsg = survey.landscapeOrientationMessage;
		} else if((isMobile || isTablet) && (this.state.divOrientation == "landscape" && survey.orientation == "portrait" && survey.orientation !== "")) {
			this.openModal = true;
			orientationMsg = survey.portraitOrientationMessage;
		} else {
			this.openModal = false;
		}

        return (
			<Fragment>
                <LoadingIndicator active={this.state.activePageNumber === null} />
					{collectionStatus !== undefined && properties && properties.completedAssessmentWorkflowOption === "1" && collectionStatus === "Completed" && sections.hasOwnProperty(completedNoticeSectionKey) ?
						<CompletionNoticeSection
							key={sections[completedNoticeSectionKey].key}
							html={sections[completedNoticeSectionKey].content}
							className={`_CompletedNoticeSectionKey ${sections[completedNoticeSectionKey].className}`}
						/>
						: properties && properties.completedAssessmentWorkflowOption !== "2" &&	collectionStatus !== "Completed" ?
						<ThankYouPage
							pageInstrumentConfiguration={pageInstrumentConfiguration}
						/>:
					<div ref={this.surveyRef} className='Survey' key={pageInstrumentConfiguration.key}>
						<bdo>
							{survey.pages !== undefined && survey.pages.length > 0 ? survey.pages.map((pageConfiguration, i) => {

								pageNumber++;

								if (pageConfiguration.contPage === true) {
									currentActivePageCountTemp = 1;
								}

								var isFirstPage = (pageNumber === 1);
								var isLastPage = (pageNumber === lastPageNumber);
								const nextPageKey = tempPages[i + 1] !== undefined ? tempPages[i + 1].key : null;
								const prevPageKey = tempPages[i - 1] !== undefined ? tempPages[i - 1].key : null;

								return <SurveyPage
											key={pageConfiguration.key}
											activePageKey={pageConfiguration.key}
											nextPageKey={nextPageKey}
											prevPageKey={prevPageKey}
											configuration={pageConfiguration}
											ratees={ratees}
											survey={survey}
											pageNumber={pageNumber}
											isFirstPage={isFirstPage}
											isLastPage={isLastPage}
											isFinish={isFinish}
											currentActivePageCount={currentActivePageCountTemp}
											isActivePage={pageNumber === activePageNumber}
											activePageNumber={activePageNumber}
											totalPageNumber={lastPageNumber}
											itemResponses={this.itemResponses}
											itemTempResponses={this.itemTempResponses}
											pageInstrumentConfiguration={pageInstrumentConfiguration}
											dataCollectionGuid={dataCollectionGuid}
											authorizationTokenGuid={authorizationTokenGuid}
											elapsedTimeForPutAll={this.elapsedTimeForPutAll}
											putAllForMultipleCollection={this.putAllForMultipleCollection}
											putAllForItemCollection={this.putAllForItemCollection}
											horizontalAlignment={pageConfiguration.horizontalAlignment}
											blockMovingForwardUntilRequiredItemsAnswered={pageConfiguration.blockMovingForwardUntilRequiredItemsAnswered}
											onPreviousButtonClick={(back) => this.handlePreviousButtonClick(back)}
											onNextButtonClick={(index, type, activePageNumber) => this.handleNextButtonClick(index, type, activePageNumber)}
											onFinishButtonClick ={() => this.handleFinishButtonClick(isFinish)}
											onNextPageButtonClick={this.handlePageNextButton}
											openOreModal = {this.openModal}
										/>
								}) : null
							}
						</bdo>
					</div>}
					<Modal
						show={this.openModal}
						onHide={this.handleClose}
						animation={true}
						centered={true}
						id="orientationModal"
						style={{backgroundColor:'#fff'}}
						>
						<Modal.Body>
							<span style={{color:"#333", fontWeight:"600", fontSize:20}}>{orientationMsg}</span>
							</Modal.Body>
						</Modal>
			</Fragment>
        );
    }
}

const mapStateToProps = state => ({
	surveyList:state.survey.surveyList,
    ratees: state.selectedAssessments.selectedAssessments,
	formGuid: state.selectedAssessments.formGuid,
	instrumentCss:state.survey.instrumentCss,
	//getAllItemResponse:state.survey.getAllItemResponse,
	sessionHeader:state.survey.sessionHeader,
	assessmentInfoDataCollection:state.survey.assessmentInfoDataCollection
});

const mapDispatchToProps = dispatch => ({
	getSessionHeader: (authorizationTokenGuid, dataCollectionGuid, dataCollectionGuidsCollection) => dispatch(getSessionHeader(authorizationTokenGuid, dataCollectionGuid, dataCollectionGuidsCollection)),
	getSurvey: (guid, surveyId, token) => dispatch(getSurvey(guid, surveyId, token)),
	getInstrument: (instrumentObj) => dispatch(getInstrument(instrumentObj)),
	// getAllResponse: (dataCollectionGuid) => dispatch(getAllResponse(dataCollectionGuid)),
	getAssessmentInfoForDataCollection: (dataCollectionGuid, authorizationTokenGuid) => dispatch(getAssessmentInfoForDataCollection(dataCollectionGuid, authorizationTokenGuid)),
	getAssessmentInfosForDataCollection: (dataCollectionGuidArr, authorizationTokenGuid) => dispatch(getAssessmentInfosForDataCollection(dataCollectionGuidArr, authorizationTokenGuid)),
})


export default connect(mapStateToProps, mapDispatchToProps)(Survey);